import { defineComponent } from 'vue';
import eventBus from '@/services/EventBus';
export default defineComponent({
    name: 'guarantee-popup',
    data() {
        return {
            openPopup: false,
        };
    },
    mounted() {
        eventBus.on('guaranteePopup', () => {
            this.openPopup = true;
        });
    },
});
// POPUPS wohnen in der popups.html.twig !!!!
// Button zum öffnen eines, bzw. dieses Popups:
// <open-popup-button popupName="guaranteePopup">
//    <div class="buttonBase buttonGreen">Klick mich</div>
// </open-popup-button>
